module.exports = __webpack_public_path__ + "assets/coupon-blue-dcc783.svg";